import React from "react";
import { motion } from "framer-motion";
import { Button } from "../ui/button";

const NoResultsMessage = ({ 
  themeMode, 
  setSearchQuery, 
  setSelectedFilter, 
  setSortByDate 
}) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      className={`p-8 ${themeMode === "vintage" ? "" : "rounded-2xl"} text-center ${
        themeMode === "light" 
          ? "bg-white shadow-lg" 
          : themeMode === "dark"
          ? "bg-gray-800/30 border border-gray-700 backdrop-blur-lg"
          : "border border-amber-800/40 bg-amber-50"
      }`}
    >
      <div className={`inline-block p-4 ${themeMode === "vintage" ? "" : "rounded-full"} mb-4 ${
        themeMode === "vintage" ? "border border-amber-900/20" : "bg-gray-100 dark:bg-gray-800"
      }`}>
        <svg xmlns="http://www.w3.org/2000/svg" className={`h-10 w-10 ${themeMode === "vintage" ? "text-amber-900/70" : "text-gray-400"}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <p className={`text-xl font-medium mb-2 ${themeMode === "vintage" ? "uppercase tracking-wide" : ""}`}>
        {themeMode === "vintage" ? "NO PLANNING APPLICATIONS FOUND" : "No planning applications found"}
      </p>
      <p className={`${themeMode === "vintage" ? "text-amber-900/70" : "opacity-70"} mb-4 ${themeMode === "vintage" ? "uppercase tracking-wide text-sm" : ""}`}>
        {themeMode === "vintage" ? "TRY ADJUSTING YOUR SEARCH CRITERIA OR FILTERS" : "Try adjusting your search criteria or filters"}
      </p>
      <Button
        variant={themeMode === "vintage" ? "outline" : "secondary"}
        onClick={() => {
          setSearchQuery("");
          setSelectedFilter("all");
          setSortByDate(false);
        }}
        className={themeMode === "vintage" ? "uppercase tracking-wide" : undefined}
      >
        {themeMode === "vintage" ? "RESET FILTERS" : "Reset Filters"}
      </Button>
    </motion.div>
  );
};

export default NoResultsMessage;